<!-- Copyright (c) 2020-2022 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details. -->
<template>
  <div v-if="showOnlyPositiveAnswer" :class="showButtonsInRow ? 'd-flex w-100' : ''">
    <BButton
      :class="showButtonsInRow ? 'ml-auto' : 'btn-block mt-3'"
      :variant="showButtonsAsLinks ? 'link' : variant"
      @click="setValue(0)">
      {{ options[0] }}
    </BButton>
  </div>

  <div
    v-else
    :class="[{ 'd-flex w-100 align-items-center': showButtonsInRow }]"
  >
    <!-- special handling for two-button row: render second first so it appears left, and push the first to the right -->
    <div v-if="showButtonsInRow && options.length === 2">
      <BButton
        class="btn-negative"
        :variant="showButtonsAsLinks ? 'link' : variant"
        @click="setValue(1)">
        {{ options[1] }}
      </BButton>

      <BButton
        class="ml-auto"
        :variant="showButtonsAsLinks ? 'link' : variant"
        @click="setValue(0)">
        {{ options[0] }}
      </BButton>
    </div>

    <!-- fallback for non-row or unexpected option counts -->
    <div v-else>
      <BButton
        v-for="(option, index) in options"
        :key="index"
        :class="showButtonsInRow ? 'mr-2' : 'btn-block mt-3'"
        :variant="showButtonsAsLinks ? 'link' : variant"
        @click="setValue(index)">
        {{ option }}
      </BButton>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue';

export default {
  name: 'ConfirmationCallback',
  components: {
    BButton,
  },
  props: {
    callback: {
      type: Object,
      required: true,
    },
    /**
     * Stage info
     */
    stage: {
      type: Object,
      default: null,
    },
    variant: {
      type: String,
      default: 'primary',
    },
  },
  mounted() {
    this.options = this.callback.getOptions();
  },
  data() {
    return {
      options: [],
    };
  },
  computed: {
    showOnlyPositiveAnswer() {
      try {
        return this.stage.showOnlyPositiveAnswer;
      } catch (e) {
        return false;
      }
    },
    showButtonsAsLinks() {
      return this.stage && this.stage.showButtonsAsLinks;
    },
    showButtonsInRow() {
      return this.stage && this.stage.showButtonsInRow;
    },
  },
  methods: {
    setValue(value) {
      this.callback.setInputValue(value);
      this.$emit('next-step');
    },
  },
};
</script>
